// This file is AUTOGENERATED, do not edit it manually!!!

export const activityList = {
    Activities: '1#Actividad#Actividades',
    Activities_Text: '1#{0} Actividad#{0} Actividades',
    activities_without_dates: 'Actividades sin fechas',
    Activity: 'Actividad',
    Activity_Billing: 'Facturable',
    Activity_Cost: 'Actividad facturable',
    Activity_CostVariance: 'Desviación de coste',
    Activity_HoursLeft: 'restante',
    Activity_InternalCost: 'Coste real',
    Activity_Profit: 'Beneficio',
    Add_Task: 'Agregar tarea',
    AITaskGeneration_projectName: 'Nombre',
    AITaskGeneration_retry: 'Reintentar',
    AITaskGeneration_title: 'Crear plan de proyecto con IA',
    All_Saved_Views: 'Todas las vistas guardadas',
    Apply_Text: 'Aplicar',
    apply_wbs_sorting: 'Aplicar orden WBS',
    Archive_Success_Message: 'El proyecto \"{0}\" ha sido archivado',
    archived_label: '(archivado)',
    Baseline_Text: 'Línea base',
    batch_info_all_checked: 'El padre y todas las subactividades están marcadas',
    batch_info_only_parent_checked: 'Solo la actividad principal está marcada',
    batch_info_sub_tasks_checked: 'Las subactividades están marcadas, pero la principal no',
    batch_info_title: 'Íconos de operaciones por lotes:',
    Board_CreateTaskInProjectPlaceholder: 'Crear en el proyecto',
    Board_ShowMore: 'Mostrar más',
    Browse_Views: 'Explorar vistas',
    Budget_problem_project: 'El coste real excede el presupuesto total',
    Budget_problem_task: 'El coste laboral real excede el presupuesto total',
    Budget_Text: 'Presupuesto',
    Budget_warning_project: 'El coste EAC excede el presupuesto total',
    Budget_warning_task: 'El coste laboral EAC excede el presupuesto total',
    By_Text: 'por',
    change_activity_type_to_label: 'Cambiar tipo de actividad a',
    ChooseTemplateDropdownLabel: 'Crear un proyecto basado en una plantilla existente',
    Counter: 'Contador de Proyectos/Actividades',
    CPI_Problem: 'El CPI está por debajo del umbral',
    Create: 'Crear',
    create_snapshot: 'Instantáneas del proyecto',
    CreateNewItem: 'Escribe aquí para crear un nuevo proyecto o actividad...',
    CreateProject_Tooltip: 'Crear un nuevo proyecto',
    CriticalPath_Text: 'Ruta crítica',
    CustomField_No: 'No',
    CustomField_Yes: 'Sí',
    DayPluralFormat: '1#Día#Días',
    Default_Text: 'Predeterminado',
    Delete_Confirmation_Title: '¿Eliminar estos objetos?',
    Delete_Entity_Confirmation_Archive_Description: '<b>En su lugar, también puedes archivar los datos del proyecto y restaurarlos cuando sea necesario.</b>',
    Delete_Project_Title: '¿Eliminar el proyecto \"{0}\" (ID {1})?',
    Delete_Task_Title: '¿Eliminar la actividad \"{0}\" (ID {1})?',
    Delete_Text: 'Eliminar',
    DeleteEntityConfirmation: 'incluyendo todos los registros de tiempo, mensajes y archivos adjuntos {0}. ¡La acción no se puede deshacer!',
    DeletePermanently: 'Eliminar permanentemente',
    DeleteVerb: '1#será eliminado permanentemente#serán eliminados permanentemente',
    DeleteVerbActivity: '1#será eliminado permanentemente#serán eliminados permanentemente',
    Dependency_AddMore_Text: 'Agregar más dependencias',
    Dependency_Cancel: 'Cancelar',
    Dependency_Choose: 'Selecciona actividad o escribe una palabra clave...',
    Dependency_days: 'días',
    Dependency_DelayWarningExample: 'Ejemplo: -34, 42',
    Dependency_DelayWarningText: 'Introduce números del -1000 al 1000',
    Dependency_DependencyCycle: 'Lo sentimos, no se puede crear la dependencia porque la actividad seleccionada crea un ciclo de dependencias.',
    Dependency_DependencyType_Text: 'Tipo de dependencia',
    Dependency_DependsOn_Text: 'Depende de',
    Dependency_FinishToStart_Minus1: 'La actividad inicia el día antes de que {0} termine',
    Dependency_FinishToStart_Minus1_Pattern: 'La actividad inicia <b>el día antes</b> de que \"{0}\" termine',
    Dependency_FinishToStart_Minus2: 'La actividad inicia {1} antes de que {0} termine',
    Dependency_FinishToStart_Minus2_Pattern: 'La actividad inicia <b>{1} antes</b> de que \"{0}\" termine',
    Dependency_FinishToStart_Plus0: 'La actividad inicia el día que {0} termina',
    Dependency_FinishToStart_Plus0_Pattern: 'La actividad inicia <b>el día</b> que \"{0}\" termina',
    Dependency_FinishToStart_Plus1: 'La actividad inicia el día después de que {0} termine',
    Dependency_FinishToStart_Plus1_Pattern: 'La actividad inicia <b>el día después</b> de que \"{0}\" termine',
    Dependency_FinishToStart_Plus2: 'La actividad inicia {1} después de que {0} termine',
    Dependency_FinishToStart_Plus2_Pattern: 'La actividad inicia <b>{1} después</b> de que \"{0}\" termine',
    Dependency_FinishWhenStarted_Text: 'La actividad termina cuando \"{0}\" comienza',
    Dependency_FinishWhenStarted_Title: 'De inicio a fin',
    Dependency_Lag_Text: 'Retraso',
    Dependency_ParentChildRelationship: 'Lo sentimos, no se puede crear la dependencia porque una de las actividades es principal y la otra es su subactividad.',
    Dependency_Reason: 'Razón',
    Dependency_Remove_Text: 'Eliminar',
    Dependency_RemoveSingleDependency_Text: 'Eliminar dependencia',
    Dependency_Save: 'Guardar',
    Dependency_SelectDependsOn_Text: 'Seleccionar depende de',
    Dependency_StartsWhenFinished_Text: 'La actividad inicia cuando \"{0}\" termina',
    Dependency_StartsWhenFinished_Title: 'De fin a inicio',
    Dependency_StartsWhenStarted_Text: 'La actividad inicia cuando \"{0}\" comienza',
    Dependency_StartsWhenStarted_Title: 'De inicio a inicio',
    Dependency_StartToFinish_Minus1: 'La actividad termina el día antes de que {0} inicie',
    Dependency_StartToFinish_Minus1_Pattern: 'La actividad termina <b>el día antes</b> de que \"{0}\" inicie',
    Dependency_StartToFinish_Minus2: 'La actividad termina {1} antes de que {0} inicie',
    Dependency_StartToFinish_Minus2_Pattern: 'La actividad termina <b>{1} antes</b> de que \"{0}\" inicie',
    Dependency_StartToFinish_Plus0: 'La actividad termina el día que {0} inicia',
    Dependency_StartToFinish_Plus0_Pattern: 'La actividad termina <b>el día</b> que \"{0}\" inicie',
    Dependency_StartToFinish_Plus1: 'La actividad termina el día después de que {0} comienza',
    Dependency_StartToFinish_Plus1_Pattern: 'La actividad termina <b>el día después</b> de que \"{0}\" comienza',
    Dependency_StartToFinish_Plus2: 'La actividad termina {1} después de que {0} comienza',
    Dependency_StartToFinish_Plus2_Pattern: 'La actividad termina <b>{1} después</b> de que \"{0}\" comienza',
    Dependency_StartToStart_Minus1: 'La actividad comienza el día antes de que {0} comience',
    Dependency_StartToStart_Minus1_Pattern: 'La actividad comienza <b>el día antes</b> de que \"{0}\" comience',
    Dependency_StartToStart_Minus2: 'La actividad comienza {1} antes de que {0} comience',
    Dependency_StartToStart_Minus2_Pattern: 'La actividad comienza <b>{1} antes</b> de que \"{0}\" comience',
    Dependency_StartToStart_Plus0: 'La actividad comienza el día que {0} comienza',
    Dependency_StartToStart_Plus0_Pattern: 'La actividad comienza <b>el día</b> que \"{0}\" comienza',
    Dependency_StartToStart_Plus1: 'La actividad comienza el día después de que {0} comience',
    Dependency_StartToStart_Plus1_Pattern: 'La actividad comienza <b>el día después</b> de que \"{0}\" comience',
    Dependency_StartToStart_Plus2: 'La actividad comienza {1} después de que {0} comience',
    Dependency_StartToStart_Plus2_Pattern: 'La actividad comienza <b>{1} después</b> de que \"{0}\" comience',
    Dependency_Warning_Text: 'No se pudo completar la operación.',
    Details: 'Detalles',
    Edit_Text: 'Editar',
    empty_sorting_list: 'No se encontraron opciones de ordenamiento',
    EnterProjectName: 'Ingrese el nombre del proyecto',
    EnterTaskName: 'Ingrese el nombre de la tarea',
    EnterViewName_Text: 'Ingrese el nombre de la vista',
    Error_DragAndDrop_BreakingHierarchy: 'Una actividad no puede ser hija de su propia subactividad.',
    Error_DragAndDrop_ChangeParentInFlattenView: 'Por favor, cambie la vista plana a jerárquica para modificar la jerarquía de actividades.',
    Error_DragAndDrop_CycleDependencies: 'Esta operación creará una dependencia cíclica (por ejemplo: la tarea A depende de la tarea B, la tarea B depende de la tarea A).',
    Error_DragAndDrop_DifferentProjects: 'No puede mover una actividad a otro proyecto (use los detalles de la actividad).',
    Error_DragAndDrop_ReorderWithSorting: 'Para reordenar actividades, debe aplicarse el orden ascendente de WBS.',
    Error_PresetNotFound: 'La vista seleccionada ha sido eliminada o dejada de compartir. Para continuar, actualice la página.',
    EstimatedHours_problem: 'Las horas reales superan las horas estimadas',
    export_activities: 'Actividades',
    export_activities_expanded_only: 'Actividades (solo expandidas)',
    Export_Activities_Text: 'Exportar actividades a CSV',
    Export_Import_Text: 'Exportar e importar',
    export_projects: 'Proyectos',
    Export_Projects_Text: 'Exportar proyectos a CSV',
    flat_view: 'Vista plana',
    From: 'de',
    Group_By_Portfolio: 'Agrupar por portafolio',
    group_by_project: 'Agrupar por proyecto',
    Hide_Counter: 'Ocultar contador de proyectos/actividades',
    Hide_Text: 'Ocultar',
    hide_uncategorized_tasks: 'Ocultar actividades que no coinciden con ningún calendario',
    Hours_Short_Text: 'h',
    Import_CSV_Text: 'Importar desde CSV',
    Import_MSProject_Text: 'Importar desde MS Project',
    Import_Text: 'Importar',
    Indicator_Counter_Snooze_Tooltip: '1#{0} elemento tiene problemas#{0} elementos tienen problemas',
    Indicator_Counter_Tooltip: 'Número de actividades en riesgo',
    Indicator_Project_Tooltip: 'El proyecto necesita atención en:',
    Indicator_Snooze_1_Week: 'Por 1 semana',
    Indicator_Snooze_4_Hours: 'Por 4 horas',
    Indicator_Snooze_Cancel: 'Cancelar posposición',
    Indicator_Snooze_Custom: 'Personalizado',
    Indicator_Snooze_Custom_Modal_Header: 'Posponer indicación',
    Indicator_Snooze_Forever: 'Para siempre',
    Indicator_Snooze_Menu_Text: 'Posponer indicación de problema',
    Indicator_Snooze_Message: 'Indicación de problema pospuesta para ti hasta {0}.',
    Indicator_Snooze_Message_Forever: 'Indicación de problema pospuesta para ti para siempre.',
    Indicator_Snooze_Until_Tomorrow: 'Hasta mañana',
    Indicator_Task_Tooltip: 'La actividad necesita atención en:',
    Learn_More_Text: 'Saber más',
    Loading_Text: 'Cargando...',
    More_Tasks: '{0} más',
    MoreActions_AddAIActivities: 'Crear plan de proyecto con IA',
    MoreActions_AddNextActivity: 'Agregar siguiente actividad',
    MoreActions_AddSubActivity: 'Agregar subactividad',
    MoreActions_SaveProjectAsTemplate: 'Guardar como plantilla',
    MoreActions_SetAsMilestone: 'Establecer como hito',
    MoreActions_UnsetAsMilestone: 'Quitar como hito',
    My_Presets: 'Mis vistas',
    My_Text: 'Yo',
    MyPresetName_Text: 'Mía',
    NewProject: 'Nuevo proyecto',
    NewProjectBasedOn: 'Nuevo proyecto basado en {0}',
    NewTask: 'Nueva tarea',
    no_custom_field_value_label: 'n/d',
    No_Portfolio: 'Sin portafolio',
    no_project_custom_fields_created_text: 'No se han creado campos personalizados para el proyecto',
    No_Templates_Text: 'No se encontraron plantillas.',
    NoSavedViews_Text: 'No se encontraron vistas guardadas.',
    Of: 'de',
    old_sort_az: 'A→Z',
    old_sort_za: 'Z→A',
    parent_activities: 'Actividades principales',
    Portfolios_Text: '1#{0} Portafolio#{0} Portafolios',
    preset_delete: 'Eliminar vista',
    preset_delete_confirmation: '¿Eliminar vista guardada \"{0}\"?',
    preset_rename: 'Renombrar vista',
    preset_save: 'Guardar vista',
    preset_saveAs: 'Guardar vista como',
    preset_share: 'Compartir con todos en este espacio',
    preset_unshare_confirmation: '¿Dejar de compartir la vista {0}?',
    Project: 'Proyecto',
    Project_ActualBudgetProfitability: 'Rentabilidad real del presupuesto',
    Project_BudgetedCost: 'Presupuesto total del proyecto',
    Project_CostVariance: 'Variación de costos',
    Project_EstimatedBudgetProfitability: 'Rentabilidad estimada del presupuesto',
    Project_Expenses: 'Gastos',
    project_info: 'Información del proyecto',
    Project_InternalCost: 'Costo real',
    Project_ProjectBilling: 'Facturación del proyecto',
    Project_ProjectProfit: 'Ganancia del proyecto',
    Project_ProjectProfitability: 'Rentabilidad',
    ProjectArchive: 'Proyecto (archivado)',
    ProjectEndDate_problem: 'El proyecto no se completó en la fecha de entrega',
    Projects: '1#Proyecto#Proyectos',
    Projects_Text: '1#{0} Proyecto#{0} Proyectos',
    Rename_Text: 'Renombrar',
    Restore_Text: 'Restaurar',
    Save_Text: 'Guardar',
    SaveAs_Text: 'Guardar como',
    Share_Text: 'Compartir',
    Shared_With_Me: 'Compartido conmigo',
    show_archived_projects: 'Mostrar proyectos archivados',
    Show_Text: 'Mostrar',
    SortBy_Text: 'Ordenar por',
    SPI_Problem: 'El SPI está por debajo del umbral',
    SubActivities: '1#Subactividad#Subactividades',
    switchToClassicUI: 'Cambiar a la interfaz antigua',
    switchToNewUI: 'Cambiar a la nueva interfaz',
    tab_Board: 'Tablero',
    tab_Calendar: 'Calendario',
    tab_Gantt: 'Gantt',
    tab_Table: 'Tabla',
    TargetProfit_warning: 'La ganancia objetivo es menor que la ganancia esperada',
    TargetProfitPercentage_warning: 'El porcentaje de ganancia objetivo (%) es menor que el porcentaje de ganancia esperada (%)',
    TaskEndDate_problem: 'La tarea no se completó en la fecha de entrega',
    TaskEndDate_warning: 'La tarea termina después que su tarea principal',
    TaskStartDate_warning: 'La tarea comienza antes que su tarea principal',
    Templates_Popup_Title: 'Basado en plantilla:',
    TimerText: '1#{0} segundo#{0} segundos',
    Tools_Menu_Text: 'Herramientas',
    Tooltip_DefaultPresetIcon: 'Selecciona o administra las vistas guardadas',
    Tooltip_RevertToDefaultPreset: 'Volver a la vista predeterminada',
    Tooltip_SaveDefaultPreset: 'Guarda tu diseño y filtros actuales como una vista',
    Tooltip_SharedByMePreset: 'Compartido por mí',
    TotalTargetRevenue_warning: 'El EAC facturable es menor que el ingreso total objetivo',
    Unarchive_Success_Message: 'El proyecto \"{0}\" ha sido desarchivado.',
    uncategorized_tasks: 'Actividades sin calendarios',
    Unshare_Text: 'Dejar de compartir',
    View_Project_Link: 'Ver proyecto',
    WBSNumber_Text: 'EDT',
    what_to_export: '¿Qué exportar?',
};
